import { createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

const slice = createSlice({
  name: 'settings',
  initialState: {
    visitTypes: [],
    banners: [],
    specialities: [],
    educations: [],
    specialInterests: [],
    states: [],
    statePaginationData: {},

    errorMsg: '',
    bannerImage: '',

    bannerPaginationData: {},

    visitLoading: false,
    bannerLoading: false,
    specialityLoading: false,
    educationLoading: false,
    specialInterestLoading: false,
    stateLoading: false,
    addStateApiSuccess: false,
    deleteStateApiSuccess: false,
    editStateApiSuccess: false,
    stateApiError: null,

    // Taluk

    talukList: [],
    talukListLoading: false,
    talukDetailsLoading: false,
    updateTalukApi: false,
    talukDetailsData: {},
    talukPaginationData: {},
    ApiError: '',
    modalOpen: false,
  },
  reducers: {
    //uploadImage
    uploadImage: (state) => {
      state.bannerImage = ''
    },
    uploadImageSuccess: (state, { payload }) => {
      state.bannerImage = payload?.payload?.data?.path
    },
    uploadImageFailed: (state) => {},

    //addVisitType
    addVisitTypeData: (state, { payload }) => {
      const last = state.visitTypes[state.visitTypes.length - 1]?.id || 0
      state.visitTypes = [
        ...state.visitTypes,
        { id: last + 1, ...payload, created_at: moment().format() },
      ]
    },
    addVisitTypeSuccess: (state) => {},
    addVisitTypeFailed: (state) => {},

    //updateVisit
    updateVisitTypeData: (state, { payload }) => {
      state.visitTypes = state.visitTypes.map((item) => {
        if (item.id === payload.id) {
          return { ...item, ...payload.data }
        } else {
          return item
        }
      })
    },
    updateVisitTypeDataSuccess: (state) => {},
    updateVisitTypeDataFailed: (state) => {},

    persistVisitType: (state, { payload }) => {
      let visitType = localStorage.getItem('visitType')
      state.visitTypes = JSON.parse(visitType)
    },

    //getVisitType
    getVisitTypeData: (state) => {
      state.visitLoading = true
      state.errorMsg = ''
    },
    getVisitTypeDataSuccess: (state, { payload: { payload } }) => {
      state.visitLoading = false
      state.visitTypes = payload.data
      localStorage.setItem('visitType', JSON.stringify(payload.data))
    },
    getVisitTypeDataFailed: (state, { payload }) => {
      state.token = null
      state.visitLoading = false
    },

    //deleteVisitType
    deleteVisitTypesData: (state, { payload }) => {
      state.visitTypes = state.visitTypes.filter((item) => item.id !== payload)
    },
    deleteVisitTypeSuccess: (state, { payload }) => {},
    deleteVisitTypeFailed: (state, { payload }) => {},

    //addBanner
    addBannerData: (state, { payload }) => {
      const last = state.banners[state.banners.length - 1]?.id || 0
      state.banners = [
        ...state.banners,
        { id: last + 1, ...payload, created_at: moment().format() },
      ]
    },
    addBannerSuccess: (state) => {},
    addBannerFailed: (state) => {},

    //updateBanner
    updateBannerData: (state, { payload }) => {
      state.banners = state.banners.map((item) => {
        if (item.id === payload.id) {
          return { ...item, ...payload.data }
        } else {
          return item
        }
      })
    },
    updateBannerDataSuccess: (state) => {},
    updateBannerDataFailed: (state) => {},

    //getBanner
    getBannerData: (state) => {
      state.bannerLoading = true
      state.errorMsg = ''
    },
    getBannerDataSuccess: (state, { payload: { payload } }) => {
      state.bannerLoading = false
      state.banners = payload.data
      state.bannerPaginationData = {
        rowCount: payload?.total,
        page: payload?.page,
        size: payload?.size,
        nextPage: payload?.next_page,
        previousPage: payload?.previous_page,
      }
    },
    getBannerDataFailed: (state, { payload }) => {
      state.bannerLoading = false
    },

    //deleteBanner
    deleteBannersData: (state, { payload }) => {
      state.banners = state.banners.filter((item) => item.id !== payload)
    },
    deleteBannerSuccess: (state, { payload }) => {},
    deleteBannerFailed: (state, { payload }) => {},

    //getSpeciality
    getSpecialityData: (state) => {
      state.specialityLoading = true
      state.errorMsg = ''
    },
    getSpecialityDataSuccess: (state, { payload: { payload } }) => {
      state.specialityLoading = false
      state.specialities = payload.data
    },
    getSpecialityDataFailed: (state, { payload }) => {
      state.token = null
      state.specialityLoading = false
    },

    //AddSpeciality
    addSpecialityData: (state, { payload }) => {
      const last = state.specialities[state.specialities.length - 1]?.id || 0
      state.specialities = [
        ...state.specialities,
        { id: last + 1, ...payload, created_at: moment().format() },
      ]
    },
    addSpecialityDataSuccess: (state) => {},
    addSpecialityDataFailed: (state) => {},

    //deleteSpeciality
    deleteSpecialityData: (state, { payload }) => {
      state.specialities = state.specialities.filter((item) => item.id !== payload)
    },
    deleteSpecialityDataSuccess: (state, { payload }) => {},
    deleteSpecialityDataFailed: (state, { payload }) => {},

    //update Speciality
    updateSpecialityData: (state, { payload }) => {
      state.specialities = state.specialities.map((item) => {
        if (item.id === payload.id) {
          return { ...item, ...payload.data }
        } else {
          return item
        }
      })
    },
    updateSpecialityDataSuccess: (state) => {},
    updateSpecialityDataFailed: (state) => {},

    //Get Education
    getEducationData: (state) => {
      state.educationLoading = true
      state.errorMsg = ''
    },
    getEducationDataSuccess: (state, { payload: { payload } }) => {
      state.educationLoading = false
      state.educations = payload.data
    },
    getEducationDataFailed: (state, { payload }) => {
      state.token = null
      state.educationLoading = false
    },

    //Add Education
    addEducationData: (state, { payload }) => {
      const last = state.educations[state.educations.length - 1]?.id || 0
      state.educations = [
        ...state.educations,
        { id: last + 1, ...payload, created_at: moment().format() },
      ]
    },
    addEducationDataSuccess: (state) => {},
    addEducationDataFailed: (state) => {},

    //delete Education
    deleteEducationData: (state, { payload }) => {
      state.educations = state.educations.filter((item) => item.id !== payload)
    },
    deleteEducationDataSuccess: (state, { payload }) => {},
    deleteEducationDataFailed: (state, { payload }) => {},

    //update Education
    updateEducationData: (state, { payload }) => {
      state.educations = state.educations.map((item) => {
        if (item.id === payload.id) {
          return { ...item, ...payload.data }
        } else {
          return item
        }
      })
    },
    updateEducationDataSuccess: (state) => {},
    updateEducationDataFailed: (state) => {},

    //Get SpecialInterest
    getSpecialInterestData: (state) => {
      state.specialInterestLoading = true
      state.errorMsg = ''
    },
    getSpecialInterestDataSuccess: (state, { payload: { payload } }) => {
      state.specialInterestLoading = false
      state.specialInterests = payload.data
    },
    getSpecialInterestDataFailed: (state, { payload }) => {
      state.token = null
      state.specialInterestLoading = false
    },

    //Add SpecialInterest
    addSpecialInterestData: (state, { payload }) => {
      const last = state.specialInterests[state.specialInterests.length - 1]?.id || 0
      state.specialInterests = [
        ...state.specialInterests,
        { id: last + 1, ...payload, created_at: moment().format() },
      ]
    },
    addSpecialInterestDataSuccess: (state) => {},
    addSpecialInterestDataFailed: (state) => {},

    //delete SpecialInterest
    deleteSpecialInterestData: (state, { payload }) => {
      state.specialInterests = state.specialInterests.filter((item) => item.id !== payload)
    },
    deleteSpecialInterestDataSuccess: (state, { payload }) => {},
    deleteSpecialInterestDataFailed: (state, { payload }) => {},

    //update SpecialInterest
    updateSpecialInterestData: (state, { payload }) => {
      state.specialInterests = state.specialInterests.map((item) => {
        if (item.id === payload.id) {
          return { ...item, ...payload.data }
        } else {
          return item
        }
      })
    },
    updateSpecialInterestDataSuccess: (state) => {},
    updateSpecialInterestDataFailed: (state) => {},

    //Get State
    getStateData: (state) => {
      // console.log(payload, 'payload')

      state.stateLoading = true
      state.errorMsg = ''
    },
    getStateDataSuccess: (state, { payload }) => {
      state.stateLoading = false
      state.states = payload.payload.data
      state.statePaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getStateDataFailed: (state, { payload }) => {
      state.token = null
      state.stateLoading = false
    },

    //Add State
    addStateData: (state, { payload }) => {
      //state.updateStateList = false
      state.stateLoading = false
      const last = state.states[state.states.length - 1]?.id || 0
      state.states = [...state.states, { id: last + 1, ...payload, created_at: moment().format() }]
    },
    addStateDataSuccess: (state, { payload }) => {
      state.updateStateList = true
      state.stateLoading = false
      state.addStateApiSuccess = true
      state.stateApiError = payload?.payload
    },
    addStateDataFailed: (state, { payload }) => {
      state.stateLoading = false
      alert(payload)
    },

    //delete State
    deleteStateData: (state, { payload }) => {
      state.stateLoading = false
      state.states = state.states.filter((item) => item.id !== payload)
    },
    deleteStateDataSuccess: (state, { payload }) => {
      state.updateStateList = true
      state.stateLoading = false
      state.deleteStateApiSuccess = true
      state.stateApiError = payload?.payload
    },
    deleteStateDataFailed: (state, { payload }) => {
      state.stateLoading = false
      alert(payload)
    },

    //update State
    updateStateData: (state, { payload }) => {
      // state.stateLoading = true
      state.states = state.states.map((item) => {
        if (item.id === payload.id) {
          return { ...item, ...payload.data }
        } else {
          return item
        }
      })
    },
    updateStateDataSuccess: (state, { payload }) => {
      state.updateStateList = true
      state.stateLoading = false
      state.editStateApiSuccess = true
      state.stateApiError = payload?.payload
    },
    updateStateDataFailed: (state, { payload }) => {
      state.stateLoading = false
      alert(payload)
    },

    // Taluk Apis
    talukListApiCall: (state, { payload }) => {
      state.talukListLoading = true
    },
    talukListApiSuccess: (state, { payload }) => {
      state.talukListLoading = false
      state.talukList = payload?.payload?.data
      state.talukPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    talukListApiFailed: (state, { payload }) => {
      state.talukListLoading = false
    },

    // Add Taluk
    addTalukApiCall: (state, { payload }) => {
      state.updateTalukApi = false
      state.modalOpen = false
    },
    addTalukApiSuccess: (state, { payload }) => {
      state.updateTalukApi = true
      state.ApiError = payload.payload
      state.modalOpen = true
    },
    addTalukApiFailed: (state, { payload }) => {
      alert(JSON.stringify(payload, null, 2))
    },

    // Update Taluk
    updateTalukApiCall: (state, { payload }) => {
      state.updateTalukApi = false
      state.modalOpen = false
      state.talukList = state.talukList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateTalukApiSuccess: (state, { payload }) => {
      state.ApiError = payload.payload
      state.modalOpen = true
      state.updateTalukApi = true
    },
    updateTalukApiFailed: (state, { payload }) => {
      alert(JSON.stringify(payload, null, 2))
    },

    // delete Taluk
    deleteTalukApiCall: (state, { payload }) => {
      let updateTalukList = state.talukList?.filter((item) => item.id !== payload?.id)
      state.talukList = updateTalukList
    },
    deleteTalukApiSuccess: (state, { payload }) => {
      state.ApiError = payload.payload
      state.modalOpen = true
    },
    deleteTalukApiFailed: (state, { payload }) => {
      alert(JSON.stringify(payload, null, 2))
    },

    // Taluk Details
    talukDetailsApiCall: (state, { payload }) => {
      state.talukDetailsLoading = true
    },
    talukDetailsSuccess: (state, { payload }) => {
      state.talukDetailsLoading = false
      // state.modalOpen = true
      // state.ApiError = payload.payload
      state.talukDetailsData = payload.payload.data
    },
    talukDetailsFailed: (state, { payload }) => {
      alert(JSON.stringify(payload, null, 2))
    },
    resetProviderManagementError: (state) => {
      state.ApiError = ''
      state.modalOpen = false
    },

    // Reset State and Errors
    resetStateError: (state) => {
      state.addStateApiSuccess = false
      state.deleteStateApiSuccess = false
      state.editStateApiSuccess = false
      state.stateApiError = null
      state.updateStateList = false
    },
  },
})

export const {
  persistVisitType,
  //addVisit
  addVisitTypeData,
  addVisitTypeSuccess,
  addVisitTypeFailed,
  //udpateVisit
  updateVisitTypeData,
  updateVisitTypeDataSuccess,
  updateVisitTypeDataFailed,
  //getVisit
  getVisitTypeData,
  getVisitTypeDataSuccess,
  getVisitTypeDataFailed,
  //deletevisit
  deleteVisitTypesData,
  deleteVisitTypeSuccess,
  deleteVisitTypeFailed,

  //addBanner
  addBannerData,
  addBannerSuccess,
  addBannerFailed,
  //updateBanner
  updateBannerData,
  updateBannerDataSuccess,
  updateBannerDataFailed,
  //getBanner
  getBannerData,
  getBannerDataSuccess,
  getBannerDataFailed,
  //deleteBanner
  deleteBannersData,
  deleteBannerSuccess,
  deleteBannerFailed,

  //get speciality
  getSpecialityData,
  getSpecialityDataFailed,
  getSpecialityDataSuccess,
  //add speciality
  addSpecialityData,
  addSpecialityDataSuccess,
  addSpecialityDataFailed,
  //delete speciality
  deleteSpecialityData,
  deleteSpecialityDataSuccess,
  deleteSpecialityDataFailed,
  //update speciality
  updateSpecialityData,
  updateSpecialityDataSuccess,
  updateSpecialityDataFailed,

  //get education
  getEducationData,
  getEducationDataFailed,
  getEducationDataSuccess,
  //add education
  addEducationData,
  addEducationDataSuccess,
  addEducationDataFailed,
  //delete education
  deleteEducationData,
  deleteEducationDataSuccess,
  deleteEducationDataFailed,
  //update education
  updateEducationData,
  updateEducationDataSuccess,
  updateEducationDataFailed,

  //get special interest
  getSpecialInterestData,
  getSpecialInterestDataFailed,
  getSpecialInterestDataSuccess,
  //add special interest
  addSpecialInterestData,
  addSpecialInterestDataSuccess,
  addSpecialInterestDataFailed,
  //delete special interest
  deleteSpecialInterestData,
  deleteSpecialInterestDataSuccess,
  deleteSpecialInterestDataFailed,
  //update special interest
  updateSpecialInterestData,
  updateSpecialInterestDataSuccess,
  updateSpecialInterestDataFailed,

  //get state
  getStateData,
  getStateDataFailed,
  getStateDataSuccess,
  //add state
  addStateData,
  addStateDataSuccess,
  addStateDataFailed,
  //delete state
  deleteStateData,
  deleteStateDataSuccess,
  deleteStateDataFailed,
  //update state
  updateStateData,
  updateStateDataSuccess,
  updateStateDataFailed,
  // Taluk
  talukListApiCall,
  talukListApiSuccess,
  talukListApiFailed,

  // Add Taluk
  addTalukApiCall,
  addTalukApiSuccess,
  addTalukApiFailed,

  // Update Taluk
  updateTalukApiCall,
  updateTalukApiSuccess,
  updateTalukApiFailed,

  // delete Taluk
  deleteTalukApiCall,
  deleteTalukApiSuccess,
  deleteTalukApiFailed,

  // Taluk Details
  talukDetailsApiCall,
  talukDetailsSuccess,
  talukDetailsFailed,
  resetProviderManagementError,

  //uploadImage
  uploadImage,
  uploadImageSuccess,
  uploadImageFailed,

  resetStateError,
} = slice.actions

export default slice.reducer
